import {
    isLoaded,
    initializeAllLoadedAccounts,
    CalendarEndpointType,
} from 'owa-calendar-cache-loader';
import type { DateRange } from 'owa-datetime-utils';
import type { LockedCalendarEventsStore } from 'owa-calendar-events-store';
import type { CalendarEvent } from 'owa-calendar-types';

export default async function fetchCalendarEventsForDateRangeAndSubscribe(
    folderId: string,
    dateRange: DateRange,
    store: LockedCalendarEventsStore,
    existingFetchPromise?: Promise<CalendarEvent[]>
) {
    if (!isLoaded(CalendarEndpointType.Outlook)) {
        await initializeAllLoadedAccounts();
    }

    const fetchPromise =
        existingFetchPromise ||
        store.fetchCalendarEventsForDateRange(folderId, dateRange).fetchPromise;

    store.subscribeNotifications(folderId);
    await fetchPromise;
}
